import { useMutation, useQueryClient } from '@tanstack/react-query';
import { tradingCompetitionKeys } from './tradingCompetition.keys';
import { registerToTradingCompetition } from './tradingCompetition.service';
export const useRegisterToTradingCompetition = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ subdomain, tradingCompetitionId, data, }) => {
            // Normalize data to ensure type is always present
            if ('accessKey' in data && 'secretKey' in data) {
                // It's a polling type
                return registerToTradingCompetition(subdomain, tradingCompetitionId, data);
            }
            else {
                // It's a webhook type - ensure type is set
                const webhookData = { ...data, type: 'webhook' };
                return registerToTradingCompetition(subdomain, tradingCompetitionId, webhookData);
            }
        },
        onSuccess: async (_, { subdomain, tradingCompetitionId }) => {
            await queryClient.invalidateQueries({
                queryKey: tradingCompetitionKeys.isUserRegistered(subdomain, tradingCompetitionId),
            });
        },
    });
};
